/**
 * Extract the pathname from a URL object.
 *
 * @param {Object} link - The link object containing a URL.
 * @param {string} link.url - The URL to extract the pathname from.
 *
 * @returns {string} The pathname extracted from the URL.
 */
export const getLinkPathname = link => {
  if (typeof window !== 'undefined')
    return new URL(link.url, window.origin).pathname
}
